import React from "react";

const Index = ({ name, price , subContent1, subContent2}) => {
  const parseContent = (text) => {
    const regex = /(\d+%?)/g; // Matches numbers and percentages
    const parts = text.split(regex); 

    return parts.map((part, index) =>
      regex.test(part) ? <b key={index}>{part}</b> : part
    );
  };
  return (
    <div>
     
      <span>{price}</span>
      <span>{name}</span>
      <div>
        {subContent1 ? <div>{parseContent(subContent1)}</div>:null}
        {subContent2 ? <div>{parseContent(subContent2)}</div>:null}
      </div>
    </div>
  );
};

export default Index;
